const scrollRow = (wrapper, speed = 0.5) => {
    let pos = 0;
    let isPaused = false;
    let isDragging = false;
    const getWidth = () => wrapper.scrollWidth / 2;
    const step = () => {
        if (!isPaused && !isDragging) {
            pos -= speed;

            const width = getWidth();
            if (Math.abs(pos) >= width) {
                pos = 0;
            }
            wrapper.style.transform = `translateX(${pos}px)`;
        }
        requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    let startX = 0;
    let startPos = 0;

    const startDrag = (pageX) => {
        isDragging = true;
        startX = pageX;
        startPos = pos;
    };

    const moveDrag = (pageX) => {
        if (!isDragging) return;
        const walk = pageX - startX;
        pos = startPos + walk;
        wrapper.style.transform = `translateX(${pos}px)`;
    };

    const stopDrag = () => {
        isDragging = false;
    };

    // desktop
    wrapper.addEventListener("mousedown", (e) => startDrag(e.pageX));
    window.addEventListener("mousemove", (e) => moveDrag(e.pageX));
    window.addEventListener("mouseup", stopDrag);

    // mobile
    wrapper.addEventListener("touchstart", (e) => startDrag(e.touches[0].pageX));
    wrapper.addEventListener("touchmove", (e) => moveDrag(e.touches[0].pageX));
    window.addEventListener("touchend", stopDrag);

    // pause on hover
    wrapper.addEventListener("mouseenter", () => {
        isPaused = true;
    });

    wrapper.addEventListener("mouseleave", () => {
        isPaused = false;
    });
};

const scrollAnimationInitRow = (block) => {
    const scope = block?.[0] || document;
    const rows = scope.querySelectorAll(
        ".bn-row.is-style-scroll-animated-row-experience, .bn-row.is-style-scroll-animated-row-awards, .bn-row.is-style-scroll-animated-row-no-border-awards"
    );

    rows.forEach(row => {
        const columns = Array.from(row.children);
        const scrollWrapper = document.createElement("div");
        scrollWrapper.classList.add("bn-row-scroll-wrapper");
        scrollWrapper.style.display = "flex";
        scrollWrapper.style.flexWrap = "nowrap";
        columns.forEach(column => {
            column.style.flex = "0 0 auto";
            scrollWrapper.appendChild(column.cloneNode(true));
        });

        columns.forEach(column => {
            column.style.flex = "0 0 auto";
            scrollWrapper.appendChild(column.cloneNode(true));
        });
        row.innerHTML = "";
        row.appendChild(scrollWrapper);
        scrollRow(scrollWrapper, 1);
    });
};

document.addEventListener("DOMContentLoaded", () => {
    if (
        !document.body.classList.contains("block-editor-page") &&
        !document.body.classList.contains("block-editor-iframe__body")
    ) {
        scrollAnimationInitRow();
    }
});